import * as t from 'io-ts';
import {filter} from 'lodash';

import {makeEnumRuntimeType} from './apiTypes';

/*
 * Constants.
 */

export enum ApplicationEntryPointActionTypesEnum {
  OPEN_SIDE_PANEL = 'open_side_panel',
}

export enum ApplicationEntryPointActionSdkVersionsEnum {
  LEGACY = 'legacy',
  v1_x = '1.x',
}

export enum ApplicationEntryPointActionFeaturesEnum {
  DEVICE_CAMERA = 'device:camera',
  DEVICE_FULLSCREEN = 'device:fullscreen',
  DEVICE_MICROPHONE = 'device:microphone',
  DEVICE_CLIPBOARD = 'device:clipboard',
  DISPLAY_CAPTURE = 'device:display-capture',
}

export const RApplicationEntryPointActionFeaturesEnum = makeEnumRuntimeType(
  ApplicationEntryPointActionFeaturesEnum,
);
const RApplicationEntryPointActionTypesEnum = makeEnumRuntimeType(ApplicationEntryPointActionTypesEnum);
const RApplicationEntryPointActionSdkVersionEnum = makeEnumRuntimeType(
  ApplicationEntryPointActionSdkVersionsEnum,
);

/*
 * Runtime type.
 */

const RApplicationEntryPointActionBase = t.readonly(
  t.type({
    label: t.union([t.string, t.undefined]),
    type: RApplicationEntryPointActionTypesEnum,
  }),
);

const RApplicationEntryPointOpenSidePanelAction = t.readonly(
  t.intersection([
    RApplicationEntryPointActionBase,
    t.type({
      type: t.literal(ApplicationEntryPointActionTypesEnum.OPEN_SIDE_PANEL),
      endpoint: t.string,
      features: t.readonlyArray(RApplicationEntryPointActionFeaturesEnum),
      sdkVersion: RApplicationEntryPointActionSdkVersionEnum,
    }),
  ]),
);

// This will be a union once we begin supporting more action types.
export const RApplicationEntryPointAction = RApplicationEntryPointOpenSidePanelAction;

/*
 * Type.
 */

export interface ApplicationEntryPointOpenSidePanelActionModel
  extends t.TypeOf<typeof RApplicationEntryPointOpenSidePanelAction> {}
export interface ApplicationEntryPointActionModel extends t.TypeOf<typeof RApplicationEntryPointAction> {}

/*
 * IO methods.
 */

export function parseApplicationEntryPointAction(
  entryPointAction: any,
): ApplicationEntryPointActionModel | undefined {
  if (!RApplicationEntryPointActionTypesEnum.is(entryPointAction.type)) {
    return undefined;
  }
  return {
    type: entryPointAction.type,
    endpoint: entryPointAction.endpoint,
    label: entryPointAction.label,
    sdkVersion: RApplicationEntryPointActionSdkVersionEnum.is(entryPointAction.sdk_version)
      ? entryPointAction.sdk_version
      : ApplicationEntryPointActionSdkVersionsEnum.LEGACY,
    features: filter(entryPointAction.features, RApplicationEntryPointActionFeaturesEnum.is),
  };
}
